var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.orderSubmission }, [
    _c("h2", { class: _vm.$style.submissionMobileTitle }, [
      _vm._v("Order Submitted!")
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.$style.checkmarkImage }, [
      _c("svg", {
        directives: [{ name: "svg", rawName: "v-svg" }],
        class: _vm.$style.checkmarkBig,
        attrs: { symbol: "checkmark-icon" }
      })
    ]),
    _vm._v(" "),
    _c("h4", { class: _vm.$style.orderSubmissionTitle }, [
      _c("span", [_vm._v("Order Confirmation")])
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.$style.orderInfo }, [
      _c("h3", { class: _vm.$style.orderInfoTitle }, [
        _vm._v("Your Order #" + _vm._s(_vm.checkId))
      ]),
      _vm._v(" "),
      _c("span", { class: _vm.$style.orderInfoType }, [
        _vm._v(_vm._s(_vm.orderTypeTitle))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.orderInfoItems },
        _vm._l(_vm.dataFields, function(data) {
          return _c("OrderField", { key: data.label, attrs: { data: data } })
        }),
        1
      ),
      _vm._v(" "),
      _vm.isCurbside
        ? _c("div", { class: _vm.$style.curbsideMessage }, [
            _c("p", [
              _vm._v(
                "\n        For curbside pickup, please call our store upon arrival to notify us!\n      "
              )
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/desktop/components/DesktopConfirmationMain.vue?vue&type=template&id=29c846f8&
// module id = null
// module chunks = 